import { QueryDefinition } from '@reduxjs/toolkit/dist/query';
import { ScrollContainer } from 'app/layout/dashboardLayout/BoxLayout';
import { IPaginatedRepsonse } from 'app/services';
import ItemsList from 'Components/ItemsList';
import { NoResultsFound } from 'Components/NoResultsFound';
import Spinner from 'Components/Spinner';
import { ReactNode } from 'react';

export interface IPaginationItemProps<R> {
  value: R;
  refetchAfterAdd?: (page?: number) => void;
  refetchAfterDelete?: (page?: number) => void;
  refetchSamePage?: (page?: number) => void;
}

export interface IPaginatedListProps<R> {
  notFoundTitle?: string;
  notFoundSubTitle?: string;
  Item?: React.ComponentType<IPaginationItemProps<R>>;
  renderItem?: (item: R) => ReactNode;
  Pagination?: React.ComponentType;
  PaginationComponent?: ReactNode;
  data?: R[];
  isLoading?: boolean;
  queryResult?: QueryDefinition<any, any, any, IPaginatedRepsonse<R>, string>;
  className?: string;
  gapItems?: boolean;
  children?: (item: R) => ReactNode;
}

export default function PaginatedList<R>({
  renderItem,
  Item,
  isLoading,
  notFoundSubTitle = '',
  notFoundTitle = 'No Results Found',
  Pagination,
  data,
  className = '',
  gapItems = true,
  PaginationComponent,
  children,
}: IPaginatedListProps<R>) {
  if (!data || isLoading) {
    return <Spinner />;
  }

  if (data && data.length === 0) {
    return <NoResultsFound title={notFoundTitle} subTitle={notFoundSubTitle} />;
  }

  return (
    <>
      <ScrollContainer
        className={`flex flex-col overflow-x-hidden ${
          gapItems ? 'gap-3' : ''
        } ${className}`}
      >
        <ItemsList
          items={data}
          Item={Item}
          gapItems={gapItems}
          className={className}
          renderItem={renderItem}
        />
      </ScrollContainer>
      {PaginationComponent}
      {Pagination && <Pagination />}
    </>
  );
}
